import type { Suggestion } from '../../aiSuggestionsPluginType';

/**
 * Returns the local ID of the node that the suggestion card should be anchored
 * to. Prefers the explicit `anchorLocalId` field on the suggestion when it is
 * present, and falls back to the `localId` from the first tool call's arguments
 * for backwards compatibility.
 */
export function getAnchorLocalId(suggestion: Suggestion): string | undefined {
	if (suggestion.anchorLocalId) {
		return suggestion.anchorLocalId;
	}
	const firstToolCall = suggestion.toolCalls?.[0];
	return firstToolCall && 'localId' in firstToolCall.arguments
		? firstToolCall.arguments.localId
		: undefined;
}
